var _excluded = ["children", "color", "fullWidth", "edges", "outlined", "disabled"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { colour, StyledIconButton } from './StyledIconButton';
function IconButton(_ref) {
  var children = _ref.children,
    color = _ref.color,
    fullWidth = _ref.fullWidth,
    edges = _ref.edges,
    outlined = _ref.outlined,
    disabled = _ref.disabled,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledIconButton, _extends({
    disableFocusRipple: true,
    disableRipple: true
  }, rest, {
    fullWidth: fullWidth,
    edges: edges,
    outlined: outlined,
    disabled: disabled,
    origcolor: color,
    color: colour(color),
    type: "button"
  }), children);
}
IconButton.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The icon element.
   */
  children: PropTypes.node.isRequired,
  /**
   * The color of the component. It supports those theme
   * colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary', 'tertiary']),
  /**
   * If `true`, the button is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one side
   * (this is often helpful for aligning the left or right side of the icon
   * with content above or below, without ruining the border size and shape).
   */
  edge: PropTypes.oneOf(['end', 'start', false]),
  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: PropTypes.oneOf(['small', 'medium']),
  /**
   * Make button edges rounded or square
   */
  edges: PropTypes.oneOf(['normal', 'rounded', 'sharp']),
  /**
   * Make the button fill the width of its container
   */
  fullWidth: PropTypes.bool,
  /**
   * Display a border around the icon
   */
  outlined: PropTypes.bool
} : {};
IconButton.defaultProps = {
  color: 'default',
  disabled: false,
  edge: false,
  fullWidth: false,
  outlined: false,
  size: 'medium',
  edges: 'rounded'
};
export default IconButton;